'use client';

import { SERVICE, useDeviceInfo } from '@musinsa/packages-device-detection';
import { useCallback } from 'react';
import { useNavigate } from '../hooks/useNavigate';
import { paths29CM } from './29cm';
import { pathsMusinsa } from './musinsa';

/**
 * 프로필 수정 진입.
 * - Musinsa: native deeplink `/snap/profile/modify` (newWebview: true)
 * - 29CM: web route `/profile/edit`
 */
export const useGoProfileEdit = () => {
  const { service } = useDeviceInfo();
  const { navigate } = useNavigate();
  return useCallback(() => {
    if (service === SERVICE.MUSINSA) {
      navigate(pathsMusinsa.profileEdit(), { newWebview: true });
    } else {
      navigate(paths29CM.profileEdit());
    }
  }, [service, navigate]);
};

/**
 * 닉네임 수정 진입. 29CM 전용 (Musinsa는 native에서 통합 처리).
 */
export const useGoProfileEditNickname = () => {
  const { navigate } = useNavigate();
  return useCallback(() => navigate(paths29CM.profileEditNickname()), [navigate]);
};
